import { render } from "./TransferBookCreate.vue?vue&type=template&id=3581bc7e"
import script from "./TransferBookCreate.vue?vue&type=script&lang=js"
export * from "./TransferBookCreate.vue?vue&type=script&lang=js"

import "./TransferBookCreate.vue?vue&type=style&index=0&id=3581bc7e&lang=css"
script.render = render

export default script